import React from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import { requirementsData } from '../../utils/requirementsData';
import './Requirements.css';
import photo1 from '../../assets/images/requirements/req1.jpg';
import photo2 from '../../assets/images/requirements/req2.jpg';
import photo3 from '../../assets/images/requirements/req3.jpg';
import photo4 from '../../assets/images/requirements/req5.jpg';
import { motion } from 'framer-motion';

const Requirements = () => {
    const { language } = useLanguage();

    return (
        <div className="requirements-page">
            <div className="hero-section" style={{ backgroundImage: `url(${photo4})` }}>
                <motion.h1
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    {requirementsData[language].title}
                </motion.h1>
                <motion.div
                    className="quote-box"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                >
                    <span className="quote-mark">"</span>
                    {requirementsData[language].subtitle}
                    <span className="quote-mark">"</span>
                </motion.div>
            </div>

            <div className="content-container">
                <div className="image-section">
                    <motion.div
                        className="image-grid"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8, delay: 0.5 }}
                    >
                        <div className="image-card">
                            <img src={photo1} alt="Monastery Life" />
                            <div className="image-overlay">
                                <h3>{language === 'my' ? 'သံဃာဝတ်' : 'Sangha Robes'}</h3>
                            </div>
                        </div>
                        <div className="image-card">
                            <img src={photo2} alt="Study Materials" />
                            <div className="image-overlay">
                                <h3>{language === 'my' ? 'စာပေလေ့လာခြင်း' : 'Study Materials'}</h3>
                            </div>
                        </div>
                        <div className="image-card">
                            <img src={photo3} alt="Daily Life" />
                            <div className="image-overlay">
                                <h3>{language === 'my' ? 'နေ့စဉ်ဘဝ' : 'Daily Life'}</h3>
                            </div>
                        </div>
                    </motion.div>
                </div>

                <div className="info-section">
                    <motion.div
                        className="info-card"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.7 }}
                    >
                        <div className="icon-box">
                            <i className="fas fa-ban"></i>
                        </div>
                        <h3>{language === 'my' ? 'တားမြစ်ထားသောပစ္စည်းများ' : 'Prohibited Items'}</h3>
                        <ul>
                            <li>{language === 'my' ? 'ဖုန်းနှင့် ကွန်ပျူတာများ' : 'Phones and computers'}</li>
                            <li>{language === 'my' ? 'ကိုယ်ပိုင်ငွေဖြင့် ဝယ်ယူထားသောပစ္စည်းများ' : 'Items purchased with personal money'}</li>
                        </ul>
                    </motion.div>

                    <motion.div
                        className="info-card"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.9 }}
                    >
                        <div className="icon-box">
                            <i className="fas fa-box-open"></i>
                        </div>
                        <h3>{language === 'my' ? 'သံဃိကဘဏ္ဍာတိုက်' : 'Sanghika Treasury'}</h3>
                        <ul>
                            <li>{language === 'my' ? 'သပိတ်နှင့် သင်္ကန်းများ' : 'Alms bowls and robes'}</li>
                            <li>{language === 'my' ? 'စာအုပ်နှင့် သင်ထောက်ကူပစ္စည်းများ' : 'Books and study materials'}</li>
                        </ul>
                    </motion.div>

                    <motion.div
                        className="info-card"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 1.1 }}
                    >
                        <div className="icon-box">
                            <i className="fas fa-heart"></i>
                        </div>
                        <h3>{language === 'my' ? 'စေတနာရှင်များ၏ထောက်ပံ့မှု' : 'Donor Support'}</h3>
                        <ul>
                            <li>{language === 'my' ? 'လိုအပ်သောပစ္စည်းများ ထောက်ပံ့ပေးခြင်း' : 'Provision of necessary items'}</li>
                            <li>{language === 'my' ? 'စဉ်ဆက်မပြတ် လှူဒါန်းခြင်း' : 'Continuous support'}</li>
                        </ul>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default Requirements;